// extracted by mini-css-extract-plugin
export default {"wrapper":"AddCategory_wrapper__v18Dj","container-main":"AddCategory_container-main__n2NCC","form":"AddCategory_form__4WRsY","buttons":"AddCategory_buttons__LIEPl"};